import React from "react";

type State = {
  httpMethod: HttpMethod | "timeout";
  isVisible: boolean;
  onClose: () => void;
  showErrorModal: ({
    httpMethod,
    onPostClose,
  }: {
    httpMethod: HttpMethod | "timeout";
    onPostClose?: () => void;
  }) => void;
};

const ErrorModalStatusContext = React.createContext({} as State);

export default ErrorModalStatusContext;
